<div class="container-fluid">
    <div class="row">
        <ng-container *ngFor="let navbar of navbarList[centreIndex].subCategory">
          <ng-container *ngIf="!navbar.organisationSetting || organisationService.organisation?.organisationSetting?.[navbar.organisationSetting]">
            <div *ngxPermissionsOnly="navbar.permissionCodes" class="col-lg-3 col-md-4 col-sm-6">
                <div class="custom-card-container navs">
                    <div class="custom-card-title" [ngStyle]="{ 'background-color': navbar.headerColor }"><fa-icon *ngIf="navbar.icon" [icon]="navbar.icon" [fixedWidth]="true"></fa-icon><span class="navbar-text">{{navbar.name | translate}}</span></div>
                    <ng-container *ngFor="let subnav of navbar.subCategory">
                        <div *ngxPermissionsOnly="subnav.permissionCodes" class="custom-card-element" (click)="openNavbar(navbar)" [routerLink]="getRouterLink(subnav.routerLink)">
                            <fa-icon *ngIf="subnav.icon" [icon]="subnav.icon" [fixedWidth]="true"></fa-icon><span class="navbar-text">{{subnav.name | translate}}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
          </ng-container>
        </ng-container>
    </div>
</div>
